export class ICredentials {
    username: string = '';
    password: string = '';
}


export interface CCSession {
    next(session: any): any;
    guid: string;
    userId: string;
    applicationID: string;
    active?: boolean;
    city?: string;
    company?: string;
    department?: string;
    firstName?: string;
    fullName?: string;
    hasBaseRole?: boolean;
    internalUser?: boolean;
    lastName?: string;
    message?: string;
    physicalOffice?: string;
    sessionString?: string;
    state?: string;
    streetAddress?: string;
    telephone?: string;
    userEmail?: string;
    userName?: string;
    userRolesForApplication?: string;
    zip?: string;
}

export const internal_user = {
    guid: '',
    userId: '',
    applicationID: 'CCMS',
    active: false,
    city: '',
    company: '',
    department: '',
    firstName: '',
    fullName: '',
    hasBaseRole: false,
    internalUser: false,
    lastName: '',
    message: '',
    physicalOffice: '',
    sessionString: '',
    state: '',
    streetAddress: '',
    telephone: '',
    userEmail: '',
    userName: '',
    userRolesForApplication: '',
    zip: '',
    lastLoginTime: new Date(),
}

export class LoginResult {
    isValid: boolean = false;
    message: string = '';
}
export interface IUser {
    guid: string;
    userId: string;
    applicationID: string;
    active?: boolean;
    city?: string;
    company?: string;
    department?: string;
    firstName?: string;
    fullName?: string;
    hasBaseRole?: boolean;
    internalUser?: boolean;
    lastName?: string;
    message?: string;
    physicalOffice?: string;
    sessionString?: string;
    state?: string;
    streetAddress?: string;
    telephone?: string;
    userEmail?: string;
    userName?: string;
    userRolesForApplication?: string;
    zip?: string;
    lastLoginTime?: Date;
}
export interface IUserAuth extends CCSession {
    id?: string;
    imageURL?: string;
}

export interface IFormConfig {
    name: string;
    startDate: string;
    endDate: string;
}

export interface ILogin {
    username: string;
    password: string;
}

export interface ISetPassword {
    email: string;
    oldPassword?: string;
    password: string;
    confirmPassword: string;
    sid?: string;
}

export interface IGoogleLogin {
    token: string;
    fullName: string;
    email: string;
    imageURL: string;
}

export interface ISignUp {
    fullName: string;
    address: string;
}
export class CSignUp implements ISignUp {
    fullName: string = '';
    address: string = '';
}

export interface IUserStatus {
    pending: boolean;
    approved: boolean;
}

export interface IUserAuth extends CCSession {
    id?: string;
    imageURL?: string;
}
export class CAuthenticate implements ILogin {
    username: string = '';
    password: string = '';
}
export interface ILogin {
    username: string;
    password: string;
}

export interface ISetPassword {
    email: string;
    oldPassword?: string;
    password: string;
    confirmPassword: string;
    sid?: string;
}

export interface IGoogleLogin {
    token: string;
    fullName: string;
    email: string;
    imageURL: string;
}

export interface ISignUp {
    fullName: string;
    address: string;
}

export interface IUserStatus {
    pending: boolean;
    approved: boolean;
    lean;
}

export interface CCDataOptions {
    session: CCSession;
    actionKey: string;
    data: any;
    asString?: boolean;
    url?: string;
    withCredentials?: boolean;
    sendCorpHeaders?: boolean;
}

export interface CCDataDefinition {
    sid: string;
    userID: string;
    applicationID: string;
    corpProcessDataDefinition: string;
}
